import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitDown1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowSplitDown1"><Path d="M12.75 11.6895L19.5 18.4395V14H21V21H14V19.5H18.4395L12 13.0605L5.56055 19.5H10V21H3V14H4.5V18.4395L11.25 11.6895V3H12.75V11.6895Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowSplitDown1;
